// import '@mdi/font/css/materialdesignicons.css'

// import Vue from 'vue';
// import VueMask from 'v-mask'

// Vue.use(VueMask, {
//     placeholders: {
//       A: /[0-9A-Za-z*]/,
//       S: /[A-Za-z*]/,
//       0: /[0-9*]/,
//       '#': null,
//       N	: null,
//       X: null, 
//     }
// });



export default {
  placeholders: {
    A: /[0-9A-Za-z*]/,
    S: /[A-Za-z*]/,
    0: /[0-9*]/,
    '#': null,
    N	: null,
    X: null, 
  }
}